import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

/**
 * Состояние сокета GraphQL-подписок:
 * - `idle` — соединения нет и оно не нужно (нет подписок, вышли из аккаунта);
 * - `connecting` — первое подключение;
 * - `connected` — связь есть;
 * - `reconnecting` — связь потеряна, graphql-ws переподключается.
 */
export type TConnectionStatus =
  'idle' | 'connecting' | 'connected' | 'reconnecting';

interface IConnectionState {
  status: TConnectionStatus;
}

const initialState: IConnectionState = {
  status: 'idle'
};

const connectionSlice = createSlice({
  name: 'connection',
  initialState,
  reducers: {
    /** Начало подключения. `isRetry` — это повтор после потери связи. */
    setConnectionConnecting: (state, action: PayloadAction<boolean>) => {
      state.status = action.payload ? 'reconnecting' : 'connecting';
    },
    setConnectionConnected: (state) => {
      state.status = 'connected';
    },
    /** Сокет закрыт не нами: graphql-ws сразу начнёт переподключаться. */
    setConnectionLost: (state) => {
      state.status = 'reconnecting';
    },
    /** Соединение не нужно: штатное закрытие или выход из аккаунта. */
    resetConnection: () => initialState
  }
});

export const {
  setConnectionConnecting,
  setConnectionConnected,
  setConnectionLost,
  resetConnection
} = connectionSlice.actions;
export default connectionSlice;
